import React from "react";
import Button from "components/Button";

export default function UploadHolidays() {
  return (
    <form>
      <label className="block mb-2 text-sm font-semibold text-slate-700 dark:text-slate-300" htmlFor="file_input">
        Upload file
      </label>
      <div className="flex items-center justify-center w-full">
        <label
          htmlFor="dropzone-file"
          className="flex flex-col items-center justify-center w-full h-40 border-2 border-slate-200 dark:border-slate-800 border-dashed rounded-2xl cursor-pointer bg-slate-50 dark:bg-slate-900/50 hover:bg-slate-100 dark:hover:bg-slate-800/80 transition-all duration-300 group"
        >
          <div className="flex flex-col items-center justify-center pt-5 pb-6">
            <svg
              className="w-10 h-10 mb-4 text-slate-400 dark:text-slate-500 group-hover:text-primary group-hover:scale-110 transition-all duration-300"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 20 16"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
              />
            </svg>
            <p className="mb-2 text-sm text-slate-500 dark:text-slate-400">
              <span className="font-bold text-slate-700 dark:text-slate-200">Click to upload</span> or drag and drop
            </p>
            <p className="text-xs text-slate-400 dark:text-slate-500 font-medium">CSV files only (max. 5MB)</p>
          </div>
          <input id="dropzone-file" type="file" className="hidden" accept=".csv" />
        </label>
      </div>
      <div className="mt-8 flex justify-end gap-3">
        <Button color="slate" type="button" onClick={() => {}}>
          Cancel
        </Button>
        <Button type="submit"> Upload CSV </Button>
      </div>
    </form>
  );
}
